import React from 'react';
import {
  Box,
  Typography,
} from '@material-ui/core';
import Dropdown from 'components/form/Dropdown';


const OPTIONS = [
  { label: 'Status', value: 'status' },
  { label: 'Group', value: 'category' },
  { label: 'Admission Type', value: 'admission_type' },
  { label: 'Application Platform', value: 'app_platform' },
  { label: 'Application Deadline', value: 'app_deadline' },
]

const SortBy = ({ sortParam, setsortParam }) => {

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end" marginBottom={2.3} marginLeft="auto">
      <Typography variant="smallBold" color="textSecondary">Sort by: </Typography>
      <Dropdown
        options={OPTIONS}
        value={sortParam}
        onChange={setsortParam}
      />
    </Box>
  );
};

export default SortBy;
